import { HiOutlineAnnotation } from "react-icons/hi";
import type { FilterState } from "../../../pages/fsrs/AnalyticsDashboardPage";
import { SyllableAnalytics } from "../charts/SyllableAnalytics";
import { SyllableTop10Lists } from "../charts/SyllableTop10Lists";

interface SyllablesTabProps {
  filters: FilterState;
}

export function SyllablesTab({ filters }: SyllablesTabProps) {
  const { selectedSlideId, selectedStudentId } = filters;

  // Empty state if no slide selected
  if (!selectedSlideId) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <HiOutlineAnnotation className="text-6xl mb-4 mx-auto text-gray-600" />
          <h3 className="h5 mb-2">Select a Slide</h3>
          <p className="text-gray-600">
            Choose a slide from the filters above to view syllable analysis
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h2 className="h4">Syllable Analysis</h2>
        <p className="text-gray-600 mt-1">
          Pronunciation performance breakdown by individual syllables
        </p>
      </div>

      {/* Section 1: Top 10 Hardest/Easiest */}
      <section>
        <h3 className="h5 mb-4">Top Performers</h3>
        <SyllableTop10Lists
          slideId={selectedSlideId}
          {...(selectedStudentId && { studentId: selectedStudentId })}
        />
      </section>

      {/* Section 2: Existing Syllable Analytics (charts) */}
      <section>
        <h3 className="h5 mb-4">Detailed Analytics</h3>
        <SyllableAnalytics
          slideId={selectedSlideId}
          {...(selectedStudentId && { studentId: selectedStudentId })}
        />
      </section>

      {/* TODO: Section 3: Syllable Progress Chart (multi-line tracking) */}
      {/* TODO: Section 4: Frequency vs Performance Scatter Plot */}
      {/* TODO: Section 5: Syllable Heatmap */}
    </div>
  );
}
